// extracted by mini-css-extract-plugin
module.exports = {"OfferPage__action":"OfferPage_OfferPage__action__3sUzF","EventPage__actions":"OfferPage_EventPage__actions__1uZrh"};